import type { ChapterItem } from '@app/_proto/Protos/chapters';
import { type ParseChapterStatusReturn, parseChapterStatus } from '@app/domains/common/utils';
import { useMemo } from 'react';

export type UseChapterStatusParam = {
    chapter: ChapterItem | undefined;
};

type UseChapterStatusReturn = ParseChapterStatusReturn;

export default function useChapterStatus({ chapter }: UseChapterStatusParam): UseChapterStatusReturn {
    return useMemo(() => parseChapterStatus(chapter), [chapter]);
}
